.carouselWrapper {
  position: relative;
  overflow: hidden;
  aspect-ratio: 343 / 240;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  cursor: pointer;
  border-radius: 24px;
  margin-left: 16px;
  margin-right: 16px;
}

.carouselTrack {
  position: relative;
  white-space: nowrap;
  transition: transform 0.3s;
  height: 100%;
  display: flex;
  align-items: center;
}

.carouselButtonWrapper {
  display: none;
}

@media all and (--reefer-media-tablet-min) {
  .carouselWrapper {
    aspect-ratio: 1312 / 320;
    margin-left: 64px;
    margin-right: 64px;
  }

  .carouselButtonWrapper {
    display: block;
  }
}
